module.exports = __webpack_public_path__ + "img/torvvic.936e38d5.png";